import React, { forwardRef } from "react";

const ITEM_HEIGHT = 48;
const MAX_ITEMS = 8;

export const ListboxComponent = forwardRef(function ListboxComponent(
  props,
  ref
) {
  const { children, ...other } = props;
  const items = React.Children.toArray(children);

  const height = Math.min(items.length, MAX_ITEMS) * ITEM_HEIGHT;

  return (
    <ul
      ref={ref}
      {...other}
      style={{
        maxHeight: height,
        overflowY: "auto",
        padding: 0,
        margin: 0,
      }}>
      {items}
    </ul>
  );
});
